// Services de serrurerie proposés
export const services = [
  {
    id: 1,
    name: "Ouverture de porte",
    slug: "ouverture-porte-lieusaint",
    icon: "DoorOpen",
    shortDescription: "Ouverture de porte rapide, sans dégât, 24h/24",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
    imageAlt: "Serrurier Lieusaint ouverture de porte"
  },
  {
    id: 2,
    name: "Changement de serrure",
    slug: "changement-serrure-lieusaint",
    icon: "KeyRound",
    shortDescription: "Remplacement de serrure par des modèles certifiés A2P",
    image: "https://images.unsplash.com/photo-1641452809210-0923d1996174?w=800",
    imageAlt: "Changement de serrure Lieusaint"
  },
  {
    id: 3,
    name: "Dépannage serrurier",
    slug: "depannage-serrurier-lieusaint",
    icon: "Wrench",
    shortDescription: "Intervention rapide pour tout problème de serrurerie",
    image: "https://images.unsplash.com/photo-1565257954217-cd7535e12bcf?w=800",
    imageAlt: "Dépannage serrurier Lieusaint"
  },
  {
    id: 4,
    name: "Serrurier urgence",
    slug: "serrurier-urgence-lieusaint",
    icon: "Siren",
    shortDescription: "Service d'urgence disponible 24h/24 et 7j/7",
    image: "https://images.unsplash.com/photo-1737046315119-0119468805ab?w=800",
    imageAlt: "Serrurier urgence Lieusaint 24h/24"
  },
  {
    id: 5,
    name: "Blindage de porte",
    slug: "blindage-porte-lieusaint",
    icon: "Shield",
    shortDescription: "Renforcement et blindage de porte pour plus de sécurité",
    image: "https://images.unsplash.com/photo-1561458338-cd061b02a655?w=800",
    imageAlt: "Blindage de porte Lieusaint"
  },
  {
    id: 6,
    name: "Réparation de serrure",
    slug: "reparation-serrure-lieusaint",
    icon: "Settings",
    shortDescription: "Réparation de tous types de serrures",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
    imageAlt: "Réparation serrure Lieusaint"
  },
  {
    id: 7,
    name: "Installation serrure 3 points",
    slug: "installation-serrure-3-points-lieusaint",
    icon: "Lock",
    shortDescription: "Installation de serrures multipoints haute sécurité",
    image: "https://images.unsplash.com/photo-1641452809210-0923d1996174?w=800",
    imageAlt: "Installation serrure 3 points Lieusaint"
  }
];

// Fonction pour obtenir un service par son slug
export const getServiceBySlug = (slug) => services.find(service => service.slug === slug);

// Générer le contenu SEO pour un service
export const generateServiceContent = (service) => {
  const contents = {
    "ouverture-porte-lieusaint": {
      title: "Ouverture de porte Lieusaint (77127) – Serrurier 24h/24",
      metaDescription: "Ouverture de porte à Lieusaint par serrurier professionnel. Intervention rapide 24h/24, sans dégât. Porte claquée, clé perdue, serrure bloquée. Appelez le 06 68 03 25 61.",
      h1: "Ouverture de porte Lieusaint – Intervention rapide 24h/24",
      intro: "Vous êtes bloqué devant votre porte à Lieusaint ? Notre serrurier professionnel intervient rapidement pour ouvrir votre porte, de jour comme de nuit. Porte claquée, clé perdue ou cassée, serrure bloquée : nous avons la solution pour vous permettre de rentrer chez vous rapidement.",
      sections: [
        {
          h2: "Ouverture de porte sans destruction",
          content: "Notre serrurier à Lieusaint utilise des techniques professionnelles pour ouvrir votre porte sans l'endommager dans la grande majorité des cas. Grâce à notre outillage spécialisé et notre expertise, nous parvenons à ouvrir votre porte sans avoir à la forcer, préservant ainsi votre serrure et votre porte. L'ouverture fine ou crochetage est notre spécialité."
        },
        {
          h2: "Intervention 24h/24 à Lieusaint",
          content: "Les problèmes de porte claquée ou de clé perdue n'arrivent jamais au bon moment. C'est pourquoi notre service d'ouverture de porte à Lieusaint est disponible 24 heures sur 24, 7 jours sur 7. Que ce soit en pleine nuit, le week-end ou un jour férié, un simple appel et notre serrurier se déplace rapidement chez vous."
        },
        {
          h2: "Types d'ouvertures de porte",
          h3: ["Porte claquée", "Clé perdue ou volée", "Clé cassée dans la serrure", "Serrure bloquée ou grippée"],
          content: "Nous intervenons pour tous types de situations : porte claquée avec les clés à l'intérieur, perte de clés, vol de clés nécessitant un changement de serrure, clé cassée dans le barillet, serrure bloquée suite à une tentative d'effraction. Quelle que soit votre situation à Lieusaint, notre serrurier trouvera la solution adaptée."
        },
        {
          h2: "Tarifs transparents",
          content: "Avant toute intervention, notre serrurier vous communique un devis précis. Pas de surprise sur la facture : le prix annoncé est le prix payé. Nos tarifs pour une ouverture de porte à Lieusaint démarrent à 89€ pour une ouverture simple en journée. Facteurs pouvant influencer le prix : type de serrure, heure d'intervention, nécessité de changer la serrure après ouverture."
        }
      ]
    },
    "changement-serrure-lieusaint": {
      title: "Changement de serrure Lieusaint (77127) – Serrurier professionnel",
      metaDescription: "Changement de serrure à Lieusaint par serrurier certifié. Serrures A2P, multipoints, cylindres haute sécurité. Devis gratuit. Appelez le 06 68 03 25 61.",
      h1: "Changement de serrure Lieusaint – Serrurier professionnel",
      intro: "Besoin de changer votre serrure à Lieusaint ? Suite à un cambriolage, une perte de clés ou pour renforcer la sécurité de votre domicile, notre serrurier professionnel procède au remplacement de votre serrure par un modèle adapté à vos besoins. Installation de serrures certifiées A2P pour une protection optimale.",
      sections: [
        {
          h2: "Pourquoi changer sa serrure ?",
          content: "Plusieurs raisons peuvent vous amener à changer votre serrure à Lieusaint : après un cambriolage ou une tentative d'effraction pour sécuriser votre domicile, suite à une perte ou un vol de clés, lors d'un déménagement pour être certain d'être le seul à posséder les clés, ou simplement pour remplacer une serrure vétuste par un modèle plus sécurisé."
        },
        {
          h2: "Types de serrures installées",
          content: "Notre serrurier à Lieusaint installe tous types de serrures : serrures à encastrer, serrures en applique, serrures carénées, serrures multipoints (3, 5, 7 points). Nous travaillons avec les meilleures marques du marché : Vachette, Fichet, Bricard, Picard, Mul-T-Lock, pour vous garantir une serrure de qualité et une sécurité optimale."
        },
        {
          h2: "Serrures certifiées A2P",
          content: "Pour une sécurité maximale, nous recommandons l'installation de serrures certifiées A2P (Assurance Prévention Protection). Cette certification garantit la résistance de la serrure face aux tentatives d'effraction. Il existe 3 niveaux de certification : A2P* (5 minutes de résistance), A2P** (10 minutes) et A2P*** (15 minutes). Notre serrurier vous conseille sur le niveau adapté à vos besoins."
        },
        {
          h2: "Remplacement de cylindre",
          content: "Dans certains cas, il n'est pas nécessaire de changer toute la serrure. Le simple remplacement du cylindre (aussi appelé barillet ou canon) peut suffire à sécuriser votre porte. Cette solution est plus économique et tout aussi efficace si votre serrure est en bon état. Notre serrurier à Lieusaint évaluera la meilleure option pour votre situation."
        }
      ]
    },
    "depannage-serrurier-lieusaint": {
      title: "Dépannage serrurier Lieusaint (77127) – Intervention rapide",
      metaDescription: "Dépannage serrurier à Lieusaint disponible 24h/24. Réparation serrure, remplacement cylindre, problème de fermeture. Intervention en 30 min. Appelez le 06 68 03 25 61.",
      h1: "Dépannage serrurier Lieusaint – Intervention rapide",
      intro: "Un problème de serrurerie à Lieusaint ? Notre service de dépannage serrurier intervient rapidement pour résoudre tous vos soucis : serrure bloquée, clé qui tourne dans le vide, porte qui ne ferme plus, cylindre endommagé. Disponible 24h/24, notre serrurier se déplace en urgence.",
      sections: [
        {
          h2: "Dépannage serrure rapide",
          content: "Notre serrurier à Lieusaint est équipé pour intervenir sur tous types de problèmes de serrurerie. Serrure grippée, difficile à tourner, clé qui reste coincée : nous diagnostiquons le problème et apportons la solution adaptée. Dans de nombreux cas, une simple réparation ou un réglage suffisent à remettre votre serrure en état de fonctionnement."
        },
        {
          h2: "Problèmes courants de serrurerie",
          content: "Les pannes de serrure les plus fréquentes que nous rencontrons à Lieusaint : serrure qui grince ou qui force, clé difficile à tourner, pêne qui ne sort plus complètement, porte qui ne ferme plus correctement, serrure gelée en hiver, cylindre usé ou endommagé. Notre serrurier diagnostique rapidement la cause du problème."
        },
        {
          h2: "Réparation ou remplacement ?",
          content: "Selon l'état de votre serrure, notre serrurier vous conseillera entre une réparation et un remplacement. Si la serrure est simplement grippée ou mal réglée, une intervention de maintenance peut suffire. Si le mécanisme est endommagé ou la serrure trop ancienne, le remplacement sera préconisé pour garantir votre sécurité."
        },
        {
          h2: "Intervention en urgence",
          content: "Bloqué chez vous ou à l'extérieur suite à une panne de serrure ? Notre service de dépannage serrurier urgence à Lieusaint est disponible 24h/24. Un appel au 06 68 03 25 61 et notre serrurier se déplace rapidement, généralement en moins de 30 minutes. Devis annoncé avant intervention."
        }
      ]
    },
    "serrurier-urgence-lieusaint": {
      title: "Serrurier urgence Lieusaint (77127) – Disponible 24h/24 7j/7",
      metaDescription: "Serrurier urgence Lieusaint disponible 24h/24 et 7j/7. Intervention rapide en 15-30 min. Ouverture porte, dépannage serrure, sécurisation après effraction. Appelez le 06 68 03 25 61.",
      h1: "Serrurier urgence Lieusaint – Disponible 24h/24 7j/7",
      intro: "Besoin d'un serrurier en urgence à Lieusaint ? Notre service d'urgence est disponible 24 heures sur 24, 7 jours sur 7, y compris les week-ends et jours fériés. Porte claquée, cambriolage, serrure cassée : nous intervenons rapidement pour vous sortir de toute situation d'urgence.",
      sections: [
        {
          h2: "Disponibilité 24h/24",
          content: "Les urgences en serrurerie n'ont pas d'horaire. Que ce soit en pleine nuit, tôt le matin, le dimanche ou un jour férié, notre serrurier urgence à Lieusaint répond à votre appel. Notre équipe est organisée pour assurer une permanence 24h/24 et garantir une intervention rapide quelle que soit l'heure."
        },
        {
          h2: "Intervention rapide en 15-30 minutes",
          content: "Basés à Lieusaint, au cœur de la zone de Sénart, nous pouvons intervenir très rapidement dans toute la région. Notre temps d'intervention moyen est de 15 à 30 minutes. Nos véhicules sont équipés de tout le matériel nécessaire pour réaliser les interventions sur place, sans avoir à revenir."
        },
        {
          h2: "Situations d'urgence prises en charge",
          content: "Notre service serrurier urgence Lieusaint intervient pour : porte claquée avec clés à l'intérieur, perte ou vol de clés nécessitant un changement de serrure immédiat, cambriolage ou tentative d'effraction avec sécurisation de la porte, serrure cassée empêchant de fermer ou ouvrir, clé cassée dans la serrure."
        },
        {
          h2: "Sécurisation après cambriolage",
          content: "Victime d'un cambriolage à Lieusaint ? Notre serrurier intervient en urgence pour sécuriser votre domicile. Nous procédons au remplacement de la serrure endommagée, au renforcement de la porte si nécessaire, et vous conseillons sur les solutions de sécurisation adaptées pour éviter une récidive."
        }
      ]
    },
    "blindage-porte-lieusaint": {
      title: "Blindage de porte Lieusaint (77127) – Sécurisez votre domicile",
      metaDescription: "Blindage de porte à Lieusaint par serrurier expert. Porte blindée, blindage de porte existante, serrure haute sécurité. Devis gratuit. Appelez le 06 68 03 25 61.",
      h1: "Blindage de porte Lieusaint – Sécurisez votre domicile",
      intro: "Vous souhaitez renforcer la sécurité de votre porte d'entrée à Lieusaint ? Notre serrurier expert propose des solutions de blindage adaptées à votre budget : blindage de porte existante, installation de porte blindée, pose de serrure haute sécurité. Protégez efficacement votre domicile contre les effractions.",
      sections: [
        {
          h2: "Pourquoi blinder sa porte ?",
          content: "La porte d'entrée est le point d'accès principal pour les cambrioleurs. Une porte standard peut être forcée en quelques secondes. Le blindage de porte à Lieusaint renforce considérablement la résistance de votre porte face aux tentatives d'effraction. C'est un investissement pour votre sécurité et votre tranquillité d'esprit."
        },
        {
          h2: "Blindage de porte existante",
          content: "Il n'est pas toujours nécessaire de remplacer votre porte pour la sécuriser. Notre serrurier à Lieusaint peut blinder votre porte existante en posant une tôle en acier sur la face intérieure, en renforçant le bâti avec des cornières anti-pinces, et en installant une serrure multipoints. Solution économique et efficace."
        },
        {
          h2: "Installation porte blindée",
          content: "Pour une sécurité maximale, l'installation d'une porte blindée certifiée est la meilleure solution. Les portes blindées sont équipées d'une structure en acier, de serrures multipoints et de systèmes anti-dégondage. Nous installons des portes blindées certifiées A2P BP1, BP2 ou BP3 selon le niveau de protection souhaité."
        },
        {
          h2: "Éléments de sécurisation",
          content: "Le blindage complet d'une porte à Lieusaint comprend plusieurs éléments : tôle de blindage en acier, cornières anti-pinces sur le bâti, paumelles renforcées avec goupilles anti-dégondage, serrure multipoints certifiée A2P, cylindre de haute sécurité, protège-cylindre. Chaque élément contribue à la résistance globale."
        }
      ]
    },
    "reparation-serrure-lieusaint": {
      title: "Réparation de serrure Lieusaint (77127) – Serrurier expert",
      metaDescription: "Réparation de serrure à Lieusaint par serrurier professionnel. Serrure grippée, bloquée, cassée. Intervention rapide, tarifs transparents. Appelez le 06 68 03 25 61.",
      h1: "Réparation de serrure Lieusaint – Serrurier expert",
      intro: "Votre serrure est grippée, bloquée ou ne fonctionne plus correctement à Lieusaint ? Avant de la remplacer, notre serrurier expert examine si une réparation est possible. Dans de nombreux cas, une intervention de maintenance ou le remplacement d'une pièce suffit à remettre votre serrure en état.",
      sections: [
        {
          h2: "Diagnostic de votre serrure",
          content: "Avant toute intervention, notre serrurier à Lieusaint effectue un diagnostic complet de votre serrure. Nous identifions la cause du dysfonctionnement : usure normale, mauvais entretien, tentative d'effraction, défaut de fabrication. Ce diagnostic nous permet de vous proposer la solution la plus adaptée et la plus économique."
        },
        {
          h2: "Pannes réparables",
          content: "De nombreuses pannes de serrure peuvent être réparées sans avoir à remplacer tout le mécanisme : serrure grippée nécessitant un nettoyage et une lubrification, ressort de rappel cassé, gâche mal alignée, pêne bloqué, cylindre encrassé. Notre serrurier dispose des pièces détachées pour les réparations courantes."
        },
        {
          h2: "Entretien préventif",
          content: "Pour éviter les pannes de serrure, un entretien régulier est recommandé. Notre serrurier à Lieusaint peut effectuer une maintenance préventive : nettoyage du cylindre, lubrification du mécanisme, vérification de l'alignement, contrôle de l'usure des pièces. Un entretien annuel prolonge la durée de vie de votre serrure."
        },
        {
          h2: "Quand remplacer la serrure ?",
          content: "Si la réparation n'est pas possible ou si son coût se rapproche de celui d'une serrure neuve, notre serrurier vous conseillera le remplacement. C'est notamment le cas pour les serrures très anciennes, les serrures endommagées par une effraction, ou les serrures présentant des défauts de sécurité importants."
        }
      ]
    },
    "installation-serrure-3-points-lieusaint": {
      title: "Installation serrure 3 points Lieusaint (77127) – Haute sécurité",
      metaDescription: "Installation serrure 3 points à Lieusaint par serrurier certifié. Serrures multipoints A2P, sécurité renforcée. Devis gratuit. Appelez le 06 68 03 25 61.",
      h1: "Installation serrure 3 points Lieusaint – Haute sécurité",
      intro: "Renforcez la sécurité de votre porte d'entrée à Lieusaint avec une serrure 3 points. Ce type de serrure offre une protection nettement supérieure aux serrures mono-point grâce à ses trois points de verrouillage. Notre serrurier installe des serrures multipoints certifiées A2P pour une sécurité optimale.",
      sections: [
        {
          h2: "Avantages de la serrure 3 points",
          content: "La serrure 3 points verrouille votre porte en trois endroits simultanément : en haut, au milieu et en bas. Cette répartition des points de fermeture rend l'effraction beaucoup plus difficile. Les cambrioleurs préfèrent généralement passer leur chemin face à une porte équipée d'une serrure multipoints."
        },
        {
          h2: "Types de serrures multipoints",
          content: "Il existe plusieurs configurations de serrures multipoints : serrure 3 points (la plus courante), serrure 5 points (très haute sécurité), serrure 7 points (sécurité maximale). Les points de condamnation peuvent être latéraux, en haut et en bas, ou combinés. Notre serrurier à Lieusaint vous conseille sur le modèle adapté à votre porte."
        },
        {
          h2: "Installation professionnelle",
          content: "L'installation d'une serrure 3 points nécessite un savoir-faire professionnel. Notre serrurier à Lieusaint prend les mesures précises de votre porte, découpe les emplacements pour les points de condamnation, installe la serrure et effectue tous les réglages pour un fonctionnement optimal. Travail soigné et garanti."
        },
        {
          h2: "Serrures 3 points certifiées A2P",
          content: "Pour une sécurité reconnue par les assurances, nous recommandons les serrures 3 points certifiées A2P. Cette certification garantit que la serrure a résisté à des tests d'effraction normalisés. Une serrure A2P peut même vous permettre de bénéficier de réductions sur votre assurance habitation."
        }
      ]
    }
  };

  return contents[service.slug] || {
    title: `${service.name} Lieusaint (77127) – Serrurier professionnel`,
    metaDescription: `${service.name} à Lieusaint par serrurier professionnel. Intervention rapide, tarifs transparents. Appelez le 06 68 03 25 61.`,
    h1: `${service.name} Lieusaint – Serrurier professionnel`,
    intro: `Service de ${service.name.toLowerCase()} à Lieusaint et dans toute la zone de Sénart.`,
    sections: []
  };
};

export default services;
